import React, { useEffect } from "react";
import { X, Calendar, ShieldCheck } from "lucide-react";

const GHL_BOOKING_URL =
  process.env.REACT_APP_BOOKING_URL ||
  "https://api.leadconnectorhq.com/widget/booking/A9PcOoj4nmGc485i5SZH";

export default function BookingModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const scriptId = "ghl-form-embed-script";
    if (!document.getElementById(scriptId)) {
      const s = document.createElement("script");
      s.id = scriptId;
      s.src = "https://link.msgsndr.com/js/form_embed.js";
      s.type = "text/javascript";
      s.async = true;
      document.body.appendChild(s);
    }
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4"
      data-testid="scheduler-modal-overlay"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg border border-slate-200 max-w-3xl w-full overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-200 flex flex-col max-h-[90vh]"
        data-testid="scheduler-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-slate-900 px-6 py-4 flex justify-between items-center text-white shrink-0">
          <div className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-emerald-500" />
            <span className="font-semibold tracking-tight">Schedule Your Lead Strategy Call</span>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors"
            data-testid="modal-close-button"
            aria-label="Close modal"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* GoHighLevel Calendar Embed */}
        <div className="flex-1 overflow-y-auto bg-white">
          <iframe
            src={GHL_BOOKING_URL}
            title="Book a Consultation - Precision Home Leads LLC"
            className="w-full border-none"
            style={{ minHeight: "640px", width: "100%" }}
            scrolling="no"
            id="ghl-booking-iframe"
            data-testid="ghl-booking-iframe"
          />
        </div>

        {/* Footer trust strip */}
        <div className="px-6 py-3 border-t border-slate-100 flex items-center gap-1.5 text-xs text-slate-500 bg-slate-50 shrink-0">
          <ShieldCheck className="h-4 w-4 text-emerald-600" />
          Secure 1-on-1 Consultation • Your information is kept confidential
        </div>
      </div>
    </div>
  );
}
